/* eslint-disable eqeqeq */
import React, { useState } from "react";
import $ from "jquery";
import { Select, Checkbox } from "react-materialize";
import Html from "../../utils/Html";

export default function FilterJobClass({ data, key_form }) {
  const [jobClassFilters, setJobClassFilters] = useState({
    data: [],
    key_form: key_form,
    checked: false });
  let handleEvents = {
    BtnSelectAll: {
      OnClick: function (evt) {
        let selectedAll = false;
        if ($(evt.target).is(":checked")) {
          selectedAll = true;
        }
        let selectedArr = [];
        if (selectedAll) {
          $("#filter-inp-jobclass option").each(function () {
            if ($(this).attr("disabled") == undefined) {
              selectedArr.push($(this).val());
            }
          });
        }
        //console.log("Btn Select All => JobClass");
        setJobClassFilters({
          data: selectedArr,
          key_form: Math.random(),
          checked: selectedAll });
      } } };
  //   const n = Object.keys(data).length;
  let itemData = [...data];
  //   //itemData.push({name: "All Branch", value: 0});
  //   for (let org_id in data) {
  //     for (let i in data[org_id]) {
  //       itemData.push({
  //         name:
  //           data[org_id][i]["name"] +
  //           (n > 1 ? " (" + data[org_id][i]["org_name"] + ")" : ""),
  //         value: data[org_id][i]["id"],
  //       });
  //     }
  //   }
  return (
    <div
      key={"filter-inp-jobclasses" + key_form}
      className="filter-input-field select"
    >
      <div className="btn-select-all">
        <Checkbox
          checked={jobClassFilters.checked}
          filledIn
          className=""
          id="btn-select-all-jobclass"
          label="Select / Unselect All"
          value="yes"
          onClick={handleEvents.BtnSelectAll.OnClick}
        />
      </div>
      <Select
        multiple={true}
        key={"filter-inp-jobclass" + jobClassFilters.key_form}
        id="filter-inp-jobclass"
        name="jobclass"
        options={{
          classes: "",
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: true,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 250 } }}
        defaultValue={jobClassFilters.data}
      >
        <Html.Options
          data={itemData}
          addon={{
            key: "jobclass",
            name: "name",
            value: "value",
            title: "Job Class" }}
        />
      </Select>
      <span className="select-helper-text hide" id="helper-text-jobclass">
        Please select Job Class
      </span>
    </div>
  );
}

